import moment from "moment";
import { BaseEntity, getCachedRegionEntity } from ".";
import { IGet_markets_region_id_history_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class MarketHistoryLatestEntity extends BaseEntity {
  private _regionID: number;
  constructor(id: number, regionid: number, props: any) {
    super(id, props);
    this._regionID = regionid;
    this._dataTypeName = "Latest Market history data";
  }

  async toJson(days_to_aggregate?: number): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const regionid = this._regionID;
    const props: Partial<IGet_markets_region_id_history_200_ok[]> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      const typeEntity = await getCachedTypeEntity(id);
      const regionEntity = await getCachedRegionEntity(regionid);
      entity.properties["region_id"] = {
        type: Excel.CellValueType.double,
        basicValue: regionid,
      };
      entity.properties["type_id"] = {
        type: Excel.CellValueType.double,
        basicValue: id,
      };
      const days =
        days_to_aggregate !== undefined && days_to_aggregate > 1 ? "Last " + days_to_aggregate + " days" : "Latest";
      if (typeEntity !== null && regionEntity !== null) {
        const entityName = typeEntity.props.name;
        const regionName = regionEntity.props.name.en;
        entity.text = days + " Market history data for " + entityName + " in " + regionName;
      } else {
        entity.text = days + " Market history data for " + id + " in " + regionid;
      }
      if (props && props.length) {
        let latestDataArray = props.sort((a, b) => moment(a?.date).unix() - moment(b?.date).unix()).reverse();
        let latestData = latestDataArray[0];
        if (latestData && (days_to_aggregate == 1 || days_to_aggregate == undefined)) {
          const date = moment(latestData.date);
          entity.properties["average"] = {
            type: Excel.CellValueType.double,
            basicValue: latestData.average,
          };
          entity.properties["highest"] = {
            type: Excel.CellValueType.double,
            basicValue: latestData.highest,
          };
          entity.properties["lowest"] = {
            type: Excel.CellValueType.double,
            basicValue: latestData.lowest,
          };
          entity.properties["volume"] = {
            type: Excel.CellValueType.double,
            basicValue: latestData.volume,
          };
          entity.properties["order_count"] = {
            type: Excel.CellValueType.double,
            basicValue: latestData.order_count,
          };
          entity.properties["date"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: date.unix() / 86400 + 25569,
            numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
          };
        } else if (days_to_aggregate !== undefined && latestData && days_to_aggregate > 1) {
          let average_avg = 0;
          let max_max = 0;
          let min_min = 0;
          let combined_order_count = 0;
          let average_order_count;
          let total_volume = 0;
          let average_volume = 0;
          let days_with_data = 0;
          let days_of_data_requested = days_to_aggregate;
          let days_without_data = 0;
          var firstDateWithData = moment(latestData.date);
          var yesterday = moment().add(-1, "days");
          var targetDay = yesterday.add(-days_to_aggregate, "days");
          for (var i = 0; i < days_to_aggregate; i++) {
            const object = latestDataArray[i];
            if (object !== undefined) {
              const date = moment(object.date);
              if (date > targetDay) {
                average_avg += object.average;
                object.highest > max_max && (max_max = object.highest);
                if (object.lowest < min_min || min_min == 0) min_min = object.lowest;
                combined_order_count += object.order_count;
                total_volume += object.volume;
                days_with_data += 1;
              }
            }
          }
          days_without_data = days_of_data_requested - days_with_data;
          average_avg = average_avg / days_with_data;
          average_order_count = combined_order_count / days_with_data;
          average_volume = total_volume / days_with_data;
          entity.properties["average_average"] = {
            type: Excel.CellValueType.double,
            basicValue: average_avg,
          };
          entity.properties["highest"] = {
            type: Excel.CellValueType.double,
            basicValue: max_max,
          };
          entity.properties["lowest"] = {
            type: Excel.CellValueType.double,
            basicValue: min_min,
          };
          entity.properties["volume"] = {
            type: Excel.CellValueType.double,
            basicValue: total_volume,
          };
          entity.properties["order_count"] = {
            type: Excel.CellValueType.double,
            basicValue: combined_order_count,
          };
          entity.properties["average_volume"] = {
            type: Excel.CellValueType.double,
            basicValue: average_volume,
          };
          entity.properties["average_order_count"] = {
            type: Excel.CellValueType.double,
            basicValue: average_order_count,
          };
          entity.properties["days_without_data"] = {
            type: Excel.CellValueType.double,
            basicValue: days_without_data,
          };
          entity.properties["days_with_data"] = {
            type: Excel.CellValueType.double,
            basicValue: days_with_data,
          };
          entity.properties["days_of_data_requested"] = {
            type: Excel.CellValueType.double,
            basicValue: days_of_data_requested,
          };
          entity.properties["latest_date"] = {
            type: Excel.CellValueType.string,
            basicValue: firstDateWithData.toString(),
          };
          entity.properties["target_date"] = {
            type: Excel.CellValueType.string,
            basicValue: targetDay.toString(),
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
